import {PaymentCounter} from '@/app/js/classes/payment-counter'

const counters = []

export function handlePaymentCounters() {
  document
    .querySelectorAll('.js-payment-counter')
    .forEach(counterEl => counters.push(new PaymentCounter(counterEl)))
}

export function recalc() {
  counters.forEach(counter => {
    counter.countAndCheckResults()
    counter.checkCost()
  })
}
